<template>
    <div>
      <teleport to="body">
          <transition name="up">
              <div class="compare-slide" v-show="modalOpen">

                    <div class="npx-container">
                      <div class="compare-slide__inner">
                      <form method="get" v-bind:action="context.root_url">
                        <input type="text" name="s" placeholder="Hae..." ref="searchInput">
                        <button type="submit" class="compare-slide__button compare-slide__search-button">
                          <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="#000" fill-rule="nonzero" d="M367.96 208.12c0-88.36-71.62-159.99-159.98-159.99C119.62 48.13 48 119.76 48 208.12c0 88.35 71.62 159.98 159.98 159.98 88.36 0 159.98-71.63 159.98-159.98Zm-30.9 163.08a206.98 206.98 0 0 1-129.08 44.9C93.09 416.1 0 323 0 208.12 0 93.22 93.1.14 207.98.14c114.89 0 207.98 93.09 207.98 207.98 0 48.8-16.8 93.69-44.9 129.08l133.9 133.9a23.9 23.9 0 0 1 0 33.89c-9.4 9.3-24.6 9.4-33.9 0l-134-133.79Z"/></svg>
                        </button>
                      </form>
                    <button v-on:click="closeModal" class="compare-slide__button compare-slide__close-button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="#000" fill-rule="nonzero" d="M73.05 38.98a24.2 24.2 0 0 0-34 0c-9.4 9.3-9.3 24.6 0 34l183 183-183 183a23.9 23.9 0 0 0 0 33.9c9.4 9.3 24.6 9.4 33.9 0l183-183 183.1 183.1a23.9 23.9 0 0 0 33.9 0c9.3-9.4 9.4-24.6 0-33.9l-183-183 183.1-183.1a23.9 23.9 0 0 0 0-33.9c-9.4-9.3-24.6-9.4-33.9 0l-183 183-183.1-183.1Z"/></svg>
                    </button>
                  </div>
                  </div>
              </div>
          </transition>
      </teleport>
    </div>
</template>

<script>

export default {
    props: ['context'],
    data: function() {
        return {
            loading: false,
            modalOpen: false,
            items: [],
            type: null,
        }
    },
    methods: {
        openModal() {
            document.documentElement.classList.add('compare-slide-open');

            this.modalOpen = true;
            setTimeout(() => {
                this.$refs.searchInput.focus();
            }, 1);

        },
        closeModal() {

            document.documentElement.classList.remove('compare-slide-open');
            this.modalOpen = false;
        }
    },
    mounted() {

        document.addEventListener('open-search-overlay', () => {
            this.openModal();
        })
    }
};
</script>
